import { ReactNode } from 'react'

import { OfflineBanner } from '@containers/OfflineBanner'

import { Container, Content, Header } from './styles'

interface IHeaderContainerProps {
  header: ReactNode
  children: ReactNode
}

export function ScreenContainer({ header, children }: IHeaderContainerProps) {
  return (
    <Container>
      <Header>{header}</Header>
      <OfflineBanner />
      <Content>{children}</Content>
    </Container>
  )
}
